import { computed, unref } from 'vue';
import { useAdvisorStore } from '@stores/advisorStore.js';

function isFirmAdmin(advisor) {
  return (
    advisor?.is_firm_admin === true
  );
}

function isTeamAdminMember(advisor, team) {
  if (!advisor?.external_id || !Array.isArray(team?.members)) return false;

  return team.members.some(
      (member) =>
        member.external_id === advisor.external_id &&
      Array.isArray(member.memberships) &&
      member.memberships.some((m) => m.role === 'admin'),
  );
}

function isMember(advisor, team) {
  if (!advisor?.external_id) return false;

  if (Array.isArray(team?.members)) {
    return team.members.some((m) => m.external_id === advisor.external_id);
  }

  if (Array.isArray(team?.members)) {
    return team.members.some((m) => m.external_id === advisor.external_id);
  }

  return false;
}

export function useCanViewTeam(team) {
  const advisorStore = useAdvisorStore();

  const canViewTeam = computed(() => {
    const t = unref(team);
    const advisor = advisorStore.advisor;

    if (!advisor || !t) return false;
    // if (t.firm !== advisor.firm) return false; // Need to return 'firm' in the team response
    if (t.is_default) return true;
    if (t.owner === advisor.external_id) return true;
    if (isFirmAdmin(advisor)) return true;
    if (isMember(advisor, t)) return true;

    return false;
  });

  return { canViewTeam };
}

export function useCanUpdateTeam(team) {
  const advisorStore = useAdvisorStore();

  const canUpdateTeam = computed(() => {
    const t = unref(team);
    const advisor = advisorStore.advisor;

    if (!advisor || !t) return false;
    // if (t.firm !== advisor.firm) return false; // Need to return 'firm' in the team response
    if (t.owner === advisor.external_id) return true;
    if (isFirmAdmin(advisor)) return true;
    if (isTeamAdminMember(advisor, t)) return true;

    return false;
  });

  return { canUpdateTeam };
}

export function useCanDeleteTeam(team) {
  const advisorStore = useAdvisorStore();

  const canDeleteTeam = computed(() => {
    const t = unref(team);
    const advisor = advisorStore.advisor;

    if (!advisor || !t) return false;
    return advisor.is_firm_admin || advisor.external_id === t.owner;
  });

  return { canDeleteTeam };
}
